import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { LeadTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/lead.trackingInfo";

import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = () => {
    const event: TypedAnalyticsEvent<LeadTrackingInfo> = {
        event: EventType.Lead,
        payload: {
            eventData: {},
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};
